'use strict';

const TASK = {
  DESCRIPTION_MAX_LENGTH: 255,
  TYPE : {
    PHONE: 1,
    LINKEDIN: 2,
    MAIL: 3,
    OTHER: 4,
  },
  STATUS : {
    ON_GOING: 1,
    LATE: 2,
    DONE: 3,
  },
};

const TASK_CONSTANTS = {
  TASK,
};

export {
  TASK_CONSTANTS,
};
